import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // добавь этот импорт!
import styles from './CalculatingSection.module.scss';
import { useUserData } from '../../../../providers/UserDataProvider/useUserData';
import { Image } from '../../../../components/Image/Image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { ReviewSlide } from '../../../../components/ReviewSlide/ReviewSlide';
import 'swiper/css';
import 'swiper/css/pagination';
import cn from 'classnames';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
export const CalculatingSection = ({ content, nextSlug = '/' }) => {
  const { userData, setUserData } = useUserData();
  const { slug,title, blocks,ratingImage,ratingText,slides } = content;
  const navigate = useNavigate();
  
  const [progress, setProgress] = useState(Array(blocks.length).fill(0));
  const [currentStep, setCurrentStep] = useState(0);
  const [openPopupIdx, setOpenPopupIdx] = useState(null);

  const isAnswered = (block) =>
    userData?.answers && block.question && userData.answers[block.question.text];

  // Редирект после завершения всех прогресс-баров
  useEffect(() => {
    if (
      progress.length &&
      progress[progress.length - 1] >= (blocks[blocks.length - 1].progress || 100)
    ) {
      const timeout = setTimeout(() => {
        ampScreenCompleted(slug,title || null)
        navigate(nextSlug);
      }, 600); 
      return () => clearTimeout(timeout);
    }
  }, [progress, blocks, navigate, nextSlug]);

  // Анимация прогресса
  useEffect(() => {
    if (currentStep >= blocks.length) return; // Всё завершено

    const block = blocks[currentStep];
    const blockProgress = block.progress || 100;
    const questionProgress = block.question?.progress ?? null;

    if (
      block.question &&
      !isAnswered(block) &&
      progress[currentStep] >= questionProgress &&
      openPopupIdx === null
    ) {
      setOpenPopupIdx(currentStep);
      return;
    }

    if (openPopupIdx !== null) return;

    if (progress[currentStep] < blockProgress) {
      const timeout = setTimeout(() => {
        setProgress((prev) =>
          prev.map((val, idx) =>
            idx === currentStep
              ? Math.min(val + 1, blockProgress)
              : val
          )
        );
      }, 17);
      return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => setCurrentStep((step) => step + 1), 340);
      return () => clearTimeout(timeout);
    }
  }, [currentStep, progress, blocks, userData, openPopupIdx, isAnswered]);

  const handleAnswer = (question, answer) => {
    setUserData(prev => {
  
      const prevE = (prev?.points?.E || 0);
      const prevP = (prev?.points?.P || 0);
  
      const answerE = answer.points?.E ?? 0;
      const answerP = answer.points?.P ?? 0;
  
      return {
        ...(prev || {}),
        answers: {
          ...(((prev && prev.answers) || {})),
          [question]: answer.text,
        },
        points: {
          E: prevE + answerE,
          P: prevP + answerP,
        },
      };
    });
    setOpenPopupIdx(null);
  };
  
  
  return (
    <div className={styles.wrapper}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {blocks && (
        <div className={styles.block}>
          {blocks.map((block, index) => (
            <div key={index} className={styles.box}>
              <div className={styles.header}>
                <div className={styles.text}>{block.text}</div>
                <div className={styles.progress}>
                  {progress[index] >= (block.progress || 100)
                    ? progressDone()
                    : index < currentStep
                      ? progressDone()
                      : progress[index] > 0
                        ? `${progress[index]}%`
                        : ''}
                </div>
              </div>
              <div className={styles.line}>
                <div
                  className={styles.progressLine}
                  style={{
                    background: block.color,
                    width: `${progress[index]}%`
                  }}
                ></div>
              </div>
              {block.question &&
                openPopupIdx === index &&
                progress[index] >= block.question.progress &&
                !isAnswered(block) && (
                <div className={styles.popup}>
                  <div className={styles.popupContent}>
                    <div className={styles.question}>{block.question.text}</div>
                    <div className={styles.answers}>
                      {block.question.answers.map((answer, idx) => (
                        <div
                          key={idx}
                          className={styles.answer}
                          onClick={() => handleAnswer(block.question.text, answer)}
                        >
                          {answer.text}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {ratingImage && <Image src={ratingImage} className={styles.ratingImage}/>}
      {ratingText && <div className={styles.ratingText}>{ratingText}</div> }
      {slides &&
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            className={cn(styles.slider, 'calcSlider')}
            modules={[Autoplay,Pagination]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            autoHeight={true}
            loop={true}
          >
            {slides.map((slide, index) => {
              return (
                <SwiperSlide key={index}>
                  <ReviewSlide slide={slide} type={"onboadring"}/>
                </SwiperSlide>
              )
            })}
          </Swiper>
        }
    </div>
  );
};


const progressDone = () => (
  <span className={styles.done}>
    {/* SVG ГАЛОЧКА */}
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M6.58621 0.617639C7.56283 -0.0340052 8.83561 -0.0340044 9.81223 0.61764L11.0371 1.43491C11.2624 1.58528 11.5077 1.70339 11.7658 1.78583L13.1684 2.23389C14.2868 2.59115 15.0804 3.58625 15.1798 4.75609L15.3045 6.22327C15.3274 6.49321 15.388 6.75862 15.4845 7.01178L16.0087 8.38777C16.4267 9.48491 16.1435 10.7258 15.2908 11.5329L14.2215 12.5452C14.0248 12.7314 13.855 12.9443 13.7172 13.1775L12.9683 14.4453C12.3711 15.4561 11.2244 16.0084 10.0618 15.845L8.60361 15.6401C8.33533 15.6024 8.0631 15.6024 7.79482 15.6401L6.33668 15.845C5.17404 16.0084 4.0273 15.4561 3.43014 14.4453L2.6812 13.1775C2.5434 12.9443 2.37367 12.7314 2.17692 12.5452L1.10759 11.5329C0.254967 10.7258 -0.0282532 9.48491 0.389735 8.38777L0.913962 7.01178C1.01041 6.75862 1.07099 6.49321 1.09393 6.22327L1.21864 4.75609C1.31808 3.58625 2.11165 2.59115 3.23003 2.23389L4.63267 1.78583C4.89074 1.70339 5.13602 1.58528 5.36137 1.43491L6.58621 0.617639Z" fill="#50CA69"/>
      <path d="M5.53271 8.29948L7.15249 9.91925C7.23678 10.0035 7.37562 9.99585 7.45008 9.90277L10.3942 6.22266" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  </span>
);